/**
 * @function getSupportedNetworks
 * Utility functions for Apple Pay support and network checks.
 * includes himyan support check (QO-8023).
 */
export function getSupportedNetworks(): string[] {
  const baseNetworks = ['visa', 'masterCard', 'amex']

  const isHimyanSupported = checkHimyanSupport()

  if (isHimyanSupported) {
    return [...baseNetworks, 'himyan']
  }

  return baseNetworks
}

function checkHimyanSupport(): boolean {
  const ua = navigator.userAgent

  const iOSMatch = ua.match(/OS (\d+)_?(\d+)?/)
  if (/iPhone|iPad|iPod/.test(ua)) {
    if (iOSMatch) {
      const major = parseInt(iOSMatch[1], 10)
      const minor = parseInt(iOSMatch[2] || '0', 10)
      return isVersionAtLeast({ major, minor }, { major: 18, minor: 4 })
    }
  }

  const macOSMatch = ua.match(/Mac OS X (\d+)_(\d+)_?(\d+)?/)
  if (/Macintosh/.test(ua) && macOSMatch) {
    const major = parseInt(macOSMatch[2], 10)
    const minor = parseInt(macOSMatch[3], 10)
    return isVersionAtLeast({ major, minor }, { major: 15, minor: 4 })
  }

  return false
}

function isVersionAtLeast(
  current: { major: number; minor: number },
  required: { major: number; minor: number }
): boolean {
  if (current.major > required.major) return true
  if (current.major < required.major) return false
  return current.minor >= required.minor
}

export const isAppleOS = () => {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  return /Mac|iPhone|iPad|iPod/i.test(ua)
}
